import React from "react";
import { TbBrandCraft } from "react-icons/tb";
import "../../assets/styles/settings.css";
import { useState, useEffect } from "react";

const BrandManagement = ({ data, setData }) => {
    
    console.log("Received data in BrandManagement:", data);
    
    const [appName, setAppName] = useState("");
    const [environment, setEnvironment] = useState("");
    const [logoUrl, setLogoUrl] = useState("");
    const [primaryColor, setPrimaryColor] = useState("");
    const [secondaryColor, setSecondaryColor] = useState("");
    const [theme, setTheme] = useState("");
    
    useEffect(() => {
        if (data && data.appName) {
            setAppName(data.appName || "");
            setEnvironment(data.environment || "");
            setLogoUrl(data.branding?.logoUrl || "");
            setPrimaryColor(data.branding?.primaryColor || "");
            setSecondaryColor(data.branding?.secondaryColor || "");
            setTheme(data.branding?.theme || "");
        }
    }, [data?.appName, data?.environment, data?.branding?.logoUrl, data?.branding?.primaryColor, data?.branding?.secondaryColor, data?.branding?.theme]);
    
    // Update parent state when form fields change
    useEffect(() => {
        if (setData && appName !== undefined) {
            setData(prevData => ({
                ...prevData,
                appName,
                environment,
                branding: {
                    ...prevData.branding,
                    logoUrl,
                    primaryColor,
                    secondaryColor,
                    theme,
                }
            }));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [appName, environment, logoUrl, primaryColor, secondaryColor, theme]);
  return (
    <>
      <div className="settingsCard">
        <h4>
          <TbBrandCraft /> Brand Management
        </h4>
        <p>
          Manage app-side configurations such as app name, environment, logo,
          colors, and theme
        </p>
        <div className="body">
          <div className="inputFields">
            <form>
              <div
                className="form-header"
              >
                <div
                  className="text-inputs"
                 
                >
                  <div>
                    <label htmlFor="title">App Name</label>
                    <input
                      type="text"
                      id="title"
                      name="appName"
                      placeholder="Text here..."
                      value={appName}
                      onChange={(e) => setAppName(e.target.value)}
                    />
                  </div>
                </div>
                <div
                  className="text-inputs"
                  
                >
                  <div>
                    <label htmlFor="environment">Environment </label>
                    <br />
                    <select
                      name="environment"
                      id="environment"
                      value={environment}
                      onChange={(e) => setEnvironment(e.target.value)}
                    >
                      <option value="">---Select Environment---</option>
                      <option value="development">Development</option>
                      <option value="staging">Staging</option>
                      <option value="production">Production</option>
                    </select>
                  </div>
                </div>
               <div
                  className="text-inputs"
                 
                >
                  <div>
                    <label htmlFor="title">Logo URL</label>
                    <input
                      type="text"
                      id="title"
                      name="logoUrl"
                      value={logoUrl}
                      onChange={(e) => setLogoUrl(e.target.value)}
                      placeholder="Text here..."
                    />
                  </div>
                </div>
              </div>

              <div
                className="form-header"
              >
                <div
                  className="text-inputs"
                >
                  <div style={{ marginTop: "10px" }}>
                    <label htmlFor="primaryColor">Primary Color</label>
                    <input
                      type="text"
                      id="primaryColor"
                      name="primaryColor"
                      placeholder="Text here..."
                      value={primaryColor}
                      onChange={(e) => setPrimaryColor(e.target.value)}
                    />
                  </div>
                </div>
                <div
                  className="text-inputs"
                 
                >
                  <div style={{ marginTop: "10px" }}>
                    <label htmlFor="secondaryColor">Secondary Color </label>
                    <br />
                    <input
                      type="text"
                      id="secondaryColor"
                      name="secondaryColor"
                      placeholder="Text here..."
                      value={secondaryColor}
                      onChange={(e) => setSecondaryColor(e.target.value)}
                    />
                  </div>
                </div>
                
              </div>
              <div
                className="form-header"
              >
              <div style={{ marginTop: "10px" }}>
              <label htmlFor="theme">Theme</label>
              <select
                name="theme"
                id="theme"
                type="text"
                placeholder="Type here..."
                value={theme}
                onChange={(e) => setTheme(e.target.value)}
              >
                <option value="">---Select Theme---</option>
                <option value="light">Light</option>
                <option value="dark">Dark</option>
                <option value="system">System Default</option>
              </select>
              </div>
              </div>
            </form>
            
          </div>
        </div>
      </div>
    </>
  );
};

export default BrandManagement;



